export class HttpRequestException extends Error {
  public status: number;
  public errorCode?: string;

  constructor(status: number, message: string, errorCode?: string) {
    super(message);
    this.name = 'HttpRequestException';
    this.status = status;
    this.errorCode = errorCode;
  }
}

export const fetchClient = async (
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> => {
  const response = await fetch(input, { ...init, credentials: 'include' });

  if (!response.ok) {
    let message = response.statusText;
    let errorCode: string | undefined;

    try {
      const body = await response.json();
      message = body.message || message;
      errorCode = body.code || body.errorCode;
    } catch {
      try {
        const text = await response.text();
        if (text) message = text;
      } catch {
        // ignore — use statusText
      }
    }

    throw new HttpRequestException(response.status, message, errorCode);
  }

  return response;
};
